import { DatePipe } from "@angular/common";
import { Injectable, OnDestroy } from "@angular/core";
/*import { CalendarOptions, EventContentArg, EventSourceInput, FullCalendarComponent } from "@fullcalendar/angular";*/
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { map, distinctUntilChanged, pluck } from "rxjs/operators";
import { BlockTree, BObjectModel, BObjectSummary, BreadDik, GQueovalDik, Person, QResult, QueovalDate, QueovalParam, Select } from "../../../../models";
import { PlanningFormationModel } from "../../../../models/formation";
import { EtatPresence, FilterPlanning, PlanningOnglet, ReservationPlanning } from "../../../../models/formation/planning.model";
import { CoreService, HttpService, QueovalDateService } from "../../../../services";
import { StageService } from "../services/stage-modal.service";




@Injectable()
export class PlanningService implements OnDestroy {

  constructor(
    public service: StageService,
    protected http: HttpService,
    protected indParam: CoreService,
    private qDateService: QueovalDateService
  ) {
    this.DateDebut = qDateService.Now();
    this.DateFin = qDateService.Now();
    this._filter = new FilterPlanning();

    this.filter$ = new BehaviorSubject<FilterPlanning>(this._filter);
  }

  private _filter: FilterPlanning;
  public get Filter(): FilterPlanning {
    return this._filter;
  }
  public set Filter(value: FilterPlanning) {
    this._filter.DateDebut = value.DateDebut;
    this._filter.DateFin = value.DateFin;
    this._filter.Formateurs = value.Formateurs;
    this._filter.IndeterminateSelect = value.IndeterminateSelect;
    this._filter.ShowOnlyNew = value.ShowOnlyNew;
  }

  public filter$: BehaviorSubject<FilterPlanning>;
  private _filterLoaded: boolean = false;
  public get filterLoaded(): boolean {
    return this._filterLoaded;
  }
  public set filterLoaded(value: boolean) {
    if (!this._filterLoaded && value) {
      this._filterLoaded = value;
      this._ListeReservations = this.ListeReservations;
      this.OnRefreshDisplay();
    }
  }
  //public Filter: FilterPlanning = new FilterPlanning();


  /** Dates intervalle sélectionnée dans le planning */
  public DateDebut: QueovalDate;

  /** Dates intervalle sélectionnée dans le planning */
  public DateFin: QueovalDate;

  public DureeStage: number;

  public ListeFormateurs: Array<Person>;

  public ListeLieux: Array<Select>;
  public ListeBureaux: Array<Select>;

  public ListeDispo: Array<Select>;

  public Objets: BlockTree;

  public SumPlannedHours: number = 0;

  public refreshDisplay: number = 0;

  public nbReservShowed: number = 0;
  public nbReservToShowed: number = 0;

  public nbReservOffset: number = 14;

  public sortedReservations: Array<ReservationPlanning> = [];

  public displayShowMore: boolean = true;

  public isSelectAll: boolean;

  public ShowOnlyNewReservState: boolean = false;

  public newReservations: Array<ReservationPlanning>;

  //#region propriétés pour manager la liste des réservations
  public boParam: QueovalParam = new QueovalParam();
  public idReserv: string = '';
  //#endregion
  /** Modèle de la liste de toutes les réservations (existantes + nouvelles) */
  private _ListeReservations: Array<ReservationPlanning>;
  public get ListeReservations(): Array<ReservationPlanning> {
    if (this.filterLoaded) {
      this.ListeReservationsFilter;
      this.Sort(this._ListeReservations);
      return this._ListeReservations ?? [];
    }
    return [];
  }

  public set ListeReservations(value: Array<ReservationPlanning>) {
    this._ListeReservations = value;
    this.FilterList();
    this.CalculPlannedHours();
    //setTimeout(() => this.OnRefreshDisplay());
  }

  /**
   * Liste des réservations filtrées
   */
  public get ListeReservationsFilter(): Array<ReservationPlanning> {
    const sortedList = this.FilterList();
    this.Sort(sortedList);
    return sortedList ?? [];
  }

  public idBureauUtilisateurConnecte: string = '-1';
  private _View: PlanningOnglet = PlanningOnglet.Planning;

  public get View(): PlanningOnglet {
    return this._View;
  }
  public set View(pValue: PlanningOnglet) {
    this._View = pValue;
    this.ViewChange.next(pValue);
  }

  public ViewChange: BehaviorSubject<PlanningOnglet> = new BehaviorSubject<PlanningOnglet>(this._View);

  ngOnDestroy(): void {
  }

  private Sort(list: Array<ReservationPlanning>): Array<ReservationPlanning>{
    if (!list)
      return list;
    list.sort((a: ReservationPlanning, b: ReservationPlanning) => {
      const dtB: Date | null = this.qDateService.ToDate(b.DateDebut);
      if (!dtB || this.qDateService.IsNull(a.DateDebut) || this.qDateService.IsNull(a.DateFin)) return -1;
      const dtA: Date | null = this.qDateService.ToDate(a.DateDebut);
      if (!dtA || this.qDateService.IsNull(b.DateDebut) || this.qDateService.IsNull(b.DateFin)) return 1;
      return (dtA as Date).getTime() - (dtB as Date).getTime();
    });
    return list;
  }

  private FilterList(): Array<ReservationPlanning> {
    if (!this._ListeReservations)
      return [];
    if (!this.Filter) {
      return this._ListeReservations;
    }
    else {
      let result = this._ListeReservations;
      if (this.Filter.DateDebut && this.Filter.DateFin) {
        // filtres des dates
        result = this._ListeReservations.filter((reserv: ReservationPlanning) =>
          this.qDateService.IsNull(reserv.DateDebut) || this.qDateService.IsNull(reserv.DateFin) ||
          ((this.qDateService.IsNull(this.Filter.DateDebut) || this.qDateService.Compare(reserv.DateFin, '>=', this.Filter.DateDebut))
          && (this.qDateService.IsNull(this.Filter.DateFin) || this.qDateService.Compare(reserv.DateDebut, '<=', this.Filter.DateFin))));
      }

      // filtres sur le(s) formateur(s)
      if (this.Filter.Formateurs && this.Filter.Formateurs.length > 0) {
        // la réservation doit avoir au moins 1 formateur de la liste OU aucun
        result = result.filter((reserv: ReservationPlanning) => {
          if (reserv.Formateurs) {
            let canShow = false;
            if (!reserv.Formateurs || reserv.Formateurs.length == 0) {
              canShow = true;
            }
            reserv.Formateurs.forEach((form: Person) => {
              if (this.Filter.Formateurs.filter(formInFilter => formInFilter.Id == form.Id).length > 0) {
                canShow = true;
              }
            });
            return canShow;
          }
        }
        );
      }
      else {
        // uniquement les réservations sans formateur
        result = result.filter((reserv: ReservationPlanning) => !reserv.Formateurs || reserv.Formateurs.length == 0);
      }

      // filtre sur le switch d'affichage des réservations en cours de création
      if (this.Filter.ShowOnlyNew && this.View != PlanningOnglet.SuiviPresence) {
        result = result.filter((reserv: ReservationPlanning) => !reserv.Ident || reserv.Ident == '0');
      }

      return result;
    }

  }

  public ShowOnlyNewReserv() {
    if (this.ShowOnlyNewReservState == false) {
      this.newReservations = this.ListeReservations.filter((reserv: ReservationPlanning) => !reserv.Ident || reserv.Ident == '0');
      this.ShowOnlyNewReservState = true;
    } else {
      this.ShowOnlyNewReservState = false;
    }

    this.ListeReservationsFilter.forEach(e => e.IsSelected = false);
    this.Filter.IndeterminateSelect = false;
    this.isSelectAll = false;

    this.OnRefreshDisplay();
  }

  /**
   * Masque les propriétés demandées dans le BO_RESERV, stock la valeur d'origine de la visibilité de l'élément dans le boPropsToRemove, puis retourne le bo dans un observable
   * @param boPropsToRemove liste des propriétés que l'on veut masquer (la value est set par le GetBoReservFiltered et contient la valeur d'origine de la propriété Visible)
   */
  public GetBoReservFiltered(boPropsToRemove: Array<GQueovalDik<string, boolean>>): Observable<BObjectModel> {
    const model = new BObjectModel();
    model.IdentBO = "BO_RESERV";
    model.Mode = 'CREATE';
    return this.http.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, model).pipe(
      map((data: BObjectModel) => {

        boPropsToRemove.forEach((propToRemove: GQueovalDik<string, boolean>) => {
          const summaryToRemove: BObjectSummary | undefined = data.summary.find(props => propToRemove.Key.toLowerCase() == props.ColumnName.toLowerCase());
          if (summaryToRemove) {
            propToRemove.Value = data.Body.SelectedGroupsList[summaryToRemove.IndexGroupsList].DataList[summaryToRemove.IndexDataList].Visible;
            data.Body.SelectedGroupsList[summaryToRemove.IndexGroupsList].DataList[summaryToRemove.IndexDataList].Visible = false
            if (data.Body.SelectedGroupsList[summaryToRemove.IndexGroupsList].DataList.filter(data => data.Visible).length == 0) {
              data.Body.SelectedGroupsList[summaryToRemove.IndexGroupsList].visible = false;
            }

          }
        });
        return data;
      })
    );
  }

  private CalculPlannedHours(): void {
    this.SumPlannedHours = this._ListeReservations.map(element => Number.parseFloat(element.Duree.replace(',', '.'))).reduce((previousValue: number, currentValue: number) => previousValue + currentValue, 0);
  }


  /**
 * Rafraichissement de la liste des réservation après enregistrement / suppression
 **/
  public RefreshReserv(): void {
    this.http.getHttp<QResult<PlanningFormationModel>>(`${this.indParam.AppParams.apiUrl}api/Stage/Planning/REFRESH_LIST_RESERV/${this.service.Stage.Ident}`).subscribe
      ((result: QResult<PlanningFormationModel>) => {
        const tempsReservations = this.ListeReservations.filter(reservation => reservation.Ident && reservation.Ident == "0");
        this.ListeReservations = tempsReservations.concat(result.Value.ListeReservations);

        this.OnRefreshDisplay();
      });
  }

  public OnRefreshDisplay(resetReservShowed: boolean = true): void {
    if (resetReservShowed) {
      this.sortedReservations = [];
      this.nbReservToShowed = 0;
      this.nbReservShowed = 0;
    } else {
      let ListeReservations: Array<ReservationPlanning> = [];
      if (this.ShowOnlyNewReservState == false) {
        ListeReservations = this.ListeReservationsFilter;
      } else if (this.ShowOnlyNewReservState == true) {
        ListeReservations = this.newReservations;
      }
      this.sortedReservations = JSON.parse(JSON.stringify(this.Sort(ListeReservations.filter(reserv => this.sortedReservations.map(r => r.Ident).includes(reserv.Ident)))));
    } 
    if (this.Filter)
      this.Filter.IndeterminateSelect = false;
    this.isSelectAll = false;
    if (resetReservShowed) {
      this.PaginationReservation(false);
    }

    const dtNow = Date.now();
    if (this.refreshDisplay <= dtNow + 250)
      this.refreshDisplay = dtNow;
    this.filter$.next(this._filter);
  }

  public PaginationReservation(refreshFilter:boolean = true) {
    let ListeReservationsFilter: Array<ReservationPlanning> = [];
    if (this.ShowOnlyNewReservState == false) {
      ListeReservationsFilter = this.ListeReservationsFilter;
    } else if (this.ShowOnlyNewReservState == true) {
      ListeReservationsFilter = this.newReservations;
    }


    if (this.nbReservToShowed + this.nbReservOffset < ListeReservationsFilter.length) {
      this.nbReservToShowed += this.nbReservOffset;
      this.displayShowMore = true;
    } else {
      this.nbReservToShowed = ListeReservationsFilter.length;
      this.displayShowMore = false;
    }

    for (var i = this.nbReservShowed; i < this.nbReservToShowed; i++) {
      this.sortedReservations.splice(i, 0, ListeReservationsFilter[i]);
    }
    this.nbReservShowed = this.nbReservToShowed;
    if (refreshFilter) {
      this.filter$.next(this._filter);
    }
  }


  public PaginationInfo(): string {
    let NbReservationsFilter: number = 0;
    if (this.ShowOnlyNewReservState == false) {
      NbReservationsFilter = this.ListeReservationsFilter.length;
    } else if (this.ShowOnlyNewReservState == true) {
      NbReservationsFilter = this.newReservations.length;
    }
    let NbReservationsSuivantes = this.nbReservOffset;
    if (this.nbReservToShowed + this.nbReservOffset > NbReservationsFilter)
      NbReservationsSuivantes = NbReservationsFilter - this.nbReservToShowed;

    const message: string = `${this.nbReservToShowed} réservations visibles sur ${NbReservationsFilter.toString()}, afficher les ${NbReservationsSuivantes} suivantes.`;
    return message;

  }

  public SetReservation(ident: string, value: ReservationPlanning): void {
    const i = this._ListeReservations.findIndex(r => r.Ident == ident);
    if (i > -1) {
      this._ListeReservations[i] = value;
    }
  }
}

